<template>
  <div class="home-container">
    <div class="home-content">
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
      </div>

      <el-table
        border
        :data="
          tableData
        "
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="name" label="大门名称" align="center">
        </el-table-column>
        <el-table-column prop="address" label="大门地址" align="center">
        </el-table-column>        
        <el-table-column prop="qrecord" label="二维码" align="center">
           <template slot-scope="scope">
            <a  @click="bindQrecord(scope.row.id)" v-if="!scope.row.qrCode">生成二维码</a>
            <img v-else :src="scope.row.qrCode" alt=""  @click="addRecord(scope.row.qrCode)" width="70px" height="70px" style="cursor: pointer;">
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >修改</el-button
            >

            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="50%">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          
          label-position="center"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="大门名称" prop="name" label-width="120px">
                <el-input
                  v-model="addData.name"
                  placeholder="请输入大门名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="大门地址" prop="address" label-width="120px">
                <el-input
                  v-model="addData.address"
                  placeholder="请输入大门地址"
                ></el-input>
              </el-form-item>
            </el-col>            
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        :visible.sync="dialogVisible"
        style="z-index: 1999"
        width="30%"
      >
        <a :href="dialogImageUrl" target="downloadFile"
          ><img width="100%" :src="dialogImageUrl" alt=""
        /></a>
        <div style="width: 100%; text-align: center">点击下载二维码</div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {    
  data() {
    return {
      searchForm: {
        name: "",
      },
      checkedStr: [], //选中的名称
      checkedIds: [], //选中的id
      isShowTrue: false, //是否显示二级树
      defaultProps: {
        children: "children",
        value: "id",
        label: "name",
      },
      houseFlag:true,
      modalTitle: "新增",
      dialogVisible:false,
      dialogImageUrl:'',
      props: {
        multiple: true,
        value: "id",
        label: "name",
        checkStrictly: true,
      },
      muneListData: [], //菜单信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        id: "", 
        name: "", 
        address: "", 
      },
      addDataRules: {
        name: [
          { required: true, message: "请输入大门名称", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入大门地址", trigger: "blur" },
        ],
      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },    
    // 生成二维码
    bindQrecord(id){
        let data = {
            id,
            page:'pages/myVisit/registration/registration'
        }
      this.$Apis.visitorCodeGenerateQrCode(data).then(res=>{
        if(res.code == 200){
          this.$message.success(res.msg)
          this.onLoad()
        }else{
          this.$message.warning(res.msg)
        }
      })
    },
    // 新增角色
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.modalTitle = "新增";
      this.isAddModal = true;
    },
    // 修改角色
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row))
      this.isAddModal = true;
    },
    //删除角色
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$Apis.visitorCodeDel({ id }).then((res) => {
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("删除成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          var data = {
            id:this.addData.id || "",
            name: this.addData.name,
            address: this.addData.address,
          };
          this.$Apis.visitorCodeAddUp(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },
    // 下载二维码
    addRecord(e) {
      console.log(e)
      this.dialogVisible = true;
      this.dialogImageUrl = e;
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad()
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad()
    },
    onLoad() {
      this.isShowloading = true;
      let page = {
        size: this.pageSize,
        current: this.currentPage,
        name:this.searchForm.name
      };
      this.$Apis.visitorCodeList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}


</style>